import { GroupKeyFilter, useGroupMemberRequestUpsertMutation } from 'shared/graphql';
import { NormalizedGroupMember } from './useGroupMembers';
import { useToast } from 'shared/hooks';
import { GroupUserRequestStatus } from '@jebel/constants';
import { recordDebug, recordError } from 'shared/utils/record';

interface UseGroupMemberRejectOptions {
  group: GroupKeyFilter | undefined | null;
}

export function useGroupMemberReject(options: UseGroupMemberRejectOptions) {
  const { showMessage, showSuccess, showError, dismiss } = useToast();

  const [updateMemberStatus] = useGroupMemberRequestUpsertMutation({
    refetchQueries: ['GroupMembers'],
    awaitRefetchQueries: true,
  });

  const mutate = async (member: NormalizedGroupMember) => {
    if (!options.group) {
      recordDebug(`Group is not defined. Cannot reject member request.`);
      return;
    }

    const messageRejectingKey = `REJECTING_GROUP_MEMBER_REQUEST_${member.id}`;

    try {
      showMessage(`Rejecting member request into group.`, { id: messageRejectingKey });

      await updateMemberStatus({
        variables: {
          userId: member.user.id as string,
          groupId: options.group.id as string,
          status: GroupUserRequestStatus.Rejected,
        },
      });

      showSuccess(`Member request has been rejected.`);
    } catch (err) {
      recordError(err);

      if (err instanceof Error) {
        showError(err.message);
      }
    }

    dismiss(messageRejectingKey);
  };

  return {
    action: mutate,
  };
}
